import React from 'react';
import { ClientDeckNav } from '../components/deck/ClientDeckNav';
import {
  SlideTitle,
  SlideCaseStudyHighlight,
  SlideProblem,
  SlideSolution,
  SlideValue,
  SlideCaseStudyValue,
  SlideCaseStudyImpact,
  SlideCompetitive,
  SlideDeploymentTimeline,
  SlideDemoVideos,
  SlideClosing,
} from '../components/deck/DeckSlides';

/**
 * Client deck: hook-first order and client-focused copy. Case studies are
 * highlighted early (teaser) then split into two pages. No Investment slide.
 * Access at /client-deck (e.g. https://demo.jobotics.ai/client-deck).
 */
export default function ClientDeck() {
  return (
    <div className="min-h-screen bg-white">
      <ClientDeckNav />
      <main className="deck-export relative">
        <SlideTitle forClient />
        <SlideCaseStudyHighlight forClient />
        <SlideProblem forClient />
        <SlideSolution forClient />
        <SlideValue forClient />
        <SlideCaseStudyValue />
        <SlideCaseStudyImpact />
        <SlideCompetitive forClient />
        <SlideDeploymentTimeline />
        <SlideDemoVideos />
        <SlideClosing forClient />
      </main>
    </div>
  );
}
